import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { CleanOptions } from './clean.js';

/** Defines the "cache" verb. */
export const init: CommandInitFunction = (program) => {
  const cacheCommand = program.addSubCommand({
    name: 'cache',
    description: 'Operations related to the Cloudpack cache (requires a sub-command).',
    usage: '<command>',
    hideSharedOptions: true,
  });

  cacheCommand.addSubCommand<CleanOptions>({
    name: 'clean',
    alias: 'clear',
    description: 'Clears the Cloudpack cache.',
    getExecutor: () => import('./clean.js'),
  });
};
